export const LogoMark = ({ className = "h-8 w-8" }) => (
  <img
    src="/brand/logo-mark-sm.png"
    alt="Aviokan Technologies logo"
    className={`${className} object-contain`}
    draggable="false"
    width="240"
    height="133"
  />
);

export default function Logo({ light = false, compact = false, size = "sm" }) {
  const md = size === "md";
  return (
    <span className="inline-flex items-center gap-2.5 select-none" data-testid="aviokan-logo">
      <LogoMark className={md ? "h-10 w-10" : "h-8 w-8"} />
      {!compact && (
        <span className="leading-none">
          <span className={`block font-display font-black tracking-[0.16em] ${md ? "text-[17px]" : "text-[15px]"} ${light ? "text-white" : "text-navy"}`}>
            AVIOKAN
          </span>
          <span className={`block font-tech text-cy mt-0.5 ${md ? "text-[8px] tracking-[0.52em]" : "text-[7px] tracking-[0.48em]"}`}>
            TECHNOLOGIES
          </span>
        </span>
      )}
    </span>
  );
}
